export const excludeExtension = (name: string) =>
  name.split('.').slice(0, -1).join('.')

export function getFileDuration(file: File): Promise<number> {
  return new Promise((resolve, reject) => {
    const audio = new Audio(URL.createObjectURL(file))

    audio.addEventListener('loadedmetadata', () => {
      resolve(audio.duration)
    })
    audio.addEventListener('error', reject)
  })
}
